import ilComponent from './CurationRow'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}

